import { Clock, FileSpreadsheet, PackageCheck, Pill, ShieldCheck } from 'lucide-react';
import Container from '../../common/Container';
import ScrollReveal from '../common/ScrollReveal';

const stats = [
  {
    icon: Pill,
    value: '100%',
    label: 'Batch & Expiry Traceability',
    detail: 'Automated FEFO / FIFO dispensing',
  },
  {
    icon: Clock,
    value: '< 30s',
    label: 'POS Invoicing Speed',
    detail: 'Barcode & generic substitute lookup',
  },
  {
    icon: PackageCheck,
    value: '0%',
    label: 'Stock Loss Discrepancy',
    detail: 'Real-time multi-counter sync',
  },
  {
    icon: FileSpreadsheet,
    value: 'GST Ready',
    label: 'Multi-Slab Tax Accounting',
    detail: 'Automated input tax credit ledgers',
  },
  {
    icon: ShieldCheck,
    value: '100%',
    label: 'Drug Authority Compliant',
    detail: 'Form 20B/21B statutory receipts',
  },
];

export const PharmacyStats = () => {
  return (
    <section className="py-12 bg-slate-50 border-y border-slate-200/80 relative">
      <Container>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 lg:gap-8">
          {stats.map((item, idx) => {
            const Icon = item.icon;
            return (
              <ScrollReveal
                key={idx}
                direction="up"
                delay={idx * 100}
                className="flex flex-col items-center text-center p-4 rounded-2xl bg-white/70 hover:bg-white border border-slate-200/60 hover:border-[#0D7893]/40 hover:shadow-lg hover:shadow-[#0D7893]/5 transition-all duration-300"
              >
                <div className="p-3 rounded-xl bg-[#0D7893]/10 text-[#0D7893] mb-3">
                  <Icon className="w-6 h-6" />
                </div>
                <div className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
                  {item.value}
                </div>
                <div className="text-sm font-semibold text-slate-800 mt-1">
                  {item.label}
                </div>
                <div className="text-xs text-slate-500 mt-0.5">
                  {item.detail}
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default PharmacyStats;
